<template>
    <p>This tool was made with <a href="https://pegjs.org/">PEG.js</a> and <a href="https://vuejs.org/">Vue.js</a></p>
    <router-link to="/" class="link-success" style="font-size: 24px; text-decoration: none;">Back</router-link>
</template>